import styled from 'styled-components';

export const Cover = styled.div`
  background-color: ${({ theme }) => theme.colors.themeColor};
  background-image: linear-gradient(
      360deg,
      #050505 -42.43%,
      rgba(255, 255, 255, 0) 102.81%
    ),
    url(${({ src }) => src});
  background-size: cover;
  background-position: center center;
  width: 100%;
  min-height: 436px;
  margin-bottom: 32px;
`;

export const BadgeDateContainer = styled.div`
  display: flex;
  column-gap: 36px;
  margin-bottom: 16px;
`;

export const Categories = styled.div`
  display: flex;
  column-gap: 8px;
`;
